import { render, staticRenderFns } from "./SubsystemIframeShell.vue?vue&type=template&id=be086756&scoped=true"
import script from "./SubsystemIframeShell.vue?vue&type=script&lang=js"
export * from "./SubsystemIframeShell.vue?vue&type=script&lang=js"
import style0 from "./SubsystemIframeShell.vue?vue&type=style&index=0&id=be086756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be086756",
  null
  
)

export default component.exports